import React, { useEffect, useState } from 'react';
import Title from '../../components/common/Title';
import { Topbar } from '../../components/include/Topbar';
import { useNavigate } from 'react-router-dom';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { useDispatch } from 'react-redux';
import Loader from '../../components/common/Loader';
import { message } from '../../redux/actions/toastActions';
import { EyeIcon } from '@heroicons/react/20/solid';
import SubdomainModal from '../../components/common/SubdomainModal';

const SchoolApprovalList = () => {
  const [data, setData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [modalOpenApprove, setModalOpenApprove] = useState(false);
  const [loader, setLoader] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [subdomainError, setSubdomainError] = useState("");

  // Fetch school approval list
  useEffect(() => {
    setLoader(true);
    Postdata(HttpService.admin_school_approval_list)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          dispatch(message(res.message));
        }
        setLoader(false);
      });
  }, [refresh, dispatch]);

  // Approve school when subdomain is submitted
  const handleApproveSubmit = (subdomain) => {
    // Validation for subdomain
    const subdomainRegex = /^(?=.*[a-z])[a-z0-9]+$/;
    if (!subdomain.trim()) {
      setSubdomainError("Subdomain is required");
      return;
    } else if (!subdomainRegex.test(subdomain)) {
      setSubdomainError("Subdomain must contain only lowercase letters and numbers, and cannot be only numbers");
      return;
    }

    if (!selectedId || !subdomain) return;
    setLoader(true);
    Postdata(HttpService.admin_school_approve, { id: selectedId, subdomain })
      .then((res) => {
        if (res.status === 200) {
          setRefresh((prev) => !prev);
        }
        // dispatch(message(res.message));
        setLoader(false);
      });
    setModalOpenApprove(false);
    setSelectedId(null);
  };

  // Reject school
  const handleReject = (id) => {
    setLoader(true);
    Postdata(HttpService.admin_school_reject, { id })
      .then((res) => {
        if (res.status === 200) {
          setRefresh((prev) => !prev);
        }
        dispatch(message(res.message));
        setLoader(false);
      });
  };

  if (loader) {
    return <Loader isClass="loader_fullscreen" />;
  }

  return (
    <>
      <Title name="School Approval" />
      <Topbar title="School Approval" />
      <div className="p-6 space-y-6 pr-0">
        <div className="bg-white rounded overflow-x-auto">
          <table className="min-w-full text-sm text-left">
            <thead className="text-gray-700">
              <tr>
                <th className="px-6 py-3 font-medium">Name</th>
                <th className="px-6 py-3 font-medium">Email</th>
                <th className="px-6 py-3 font-medium">Review</th>
                <th className="px-6 py-3 font-medium">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {data?.map((item, index) => (
                <tr key={item._id || index} className="hover:bg-gray-50">
                  <td className="px-6 py-4">{item.name}</td>
                  <td className="px-6 py-4">{item.email}</td>
                  <td
                    className="px-6 py-4 hover:cursor-pointer text-center"
                    onClick={() => navigate(`/school-approval/${item._id}`)}
                  >
                    <EyeIcon className="justify-center w-5 text-gray-500" />
                  </td>
                  <td className="px-6 py-4 space-x-3">
                    <button
                      className="text-primary_main hover:underline"
                      onClick={() => {
                        setSelectedId(item._id);
                        setModalOpenApprove(true);
                      }}
                    >
                      Approve
                    </button>
                    <button
                      className="text-red-600 hover:underline"
                      onClick={() => handleReject(item._id)}
                    >
                      Reject
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.length === 0 && (
            <div className="h-[50vh] flex items-center justify-center w-full">
              <h1 className="text-center text-gray-400">No Data Found</h1>
            </div>
          )}
        </div>
        <SubdomainModal
          modalOpen={modalOpenApprove}
          setModalOpen={setModalOpenApprove}
          onSubmit={handleApproveSubmit}
          subdomainError={subdomainError}
          title="Approve School"
          message="Please enter the subdomain for the school."
        />
      </div>
    </>
  );
};

export default SchoolApprovalList;